import React, {useEffect, useState} from "react";
import Accordion from "./Accordions/Accordion";
import {getTutorialsWithCache} from "finestrapro/src/app/actions/gettutorials";

const SidebarTutorial = ({
                             sidebarOpen,
                             setSidebarOpen,
                         }: {
    sidebarOpen: boolean;
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
    const [tutorials, setTutorials] = useState<any[]>([])
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        const fetchTutorials = async () => {
            setIsLoading(true);
            try {
                const data = await getTutorialsWithCache();
                setTutorials(data);
            } catch (error) {
                console.error("Error fetching tutorials:", error);
            } finally {
                setIsLoading(false);
            }
        };

        // Only fetch when the sidebar is open to save resources
        if (sidebarOpen) {
            fetchTutorials();
        }
    }, [sidebarOpen]);

    return (
        <div className="flex relative">
            <div
                className={`absolute top-0 right-0 z-50 bg-white p-4 text-black transition-all duration-300 ${
                    sidebarOpen ? "block" : "hidden"
                }`}
                style={{ width: `500px`, height: "1000px", overflow: 'scroll' }}
            >
                {isLoading ? (
                    <div className="flex justify-center items-center h-20">
                        <p>Loading tutorials...</p>
                    </div>
                ) : tutorials.length > 0 ? (
                    <Accordion
                        items={tutorials.map((x: any, index: number) => ({
                            id: index,
                            header: <p>{x.title} - {x.description}</p>,
                            children: <p dangerouslySetInnerHTML={{ __html: x.html }} />
                        }))}
                    />
                ) : (
                    <p>No tutorials available</p>
                )}
            </div>
            {sidebarOpen && (
                <div
                    className="fixed bg-black opacity-50"
                    onClick={() => setSidebarOpen(false)}
                ></div>
            )}
        </div>
    );
};

export default SidebarTutorial;
